import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, PageContent } from "@/components/layout/PageHeader";
import { Button } from "@/components/ui/button";
import { CheckCheck, AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";

const levelMeta = {
  info: { icon: Info, color: "text-blue-400 bg-blue-600/10 border-blue-500/30" },
  success: { icon: CheckCircle2, color: "text-emerald-400 bg-emerald-600/10 border-emerald-500/30" },
  warning: { icon: AlertTriangle, color: "text-amber-400 bg-amber-600/10 border-amber-500/30" },
  error: { icon: XCircle, color: "text-red-400 bg-red-600/10 border-red-500/30" },
};

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/notifications"); setItems(data); };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifiche" subtitle="Eventi di sistema, alert e log delle pubblicazioni.">
        <Button onClick={markAll} variant="outline" data-testid="mark-all-read" className="border-slate-700"><CheckCheck size={16} className="mr-1" />Segna tutto come letto</Button>
      </PageHeader>
      <PageContent>
        {items.length === 0 ? (
          <div className="text-sm text-slate-500 py-12 text-center border border-dashed border-slate-800 rounded-md">Nessuna notifica.</div>
        ) : (
          <div className="space-y-2">
            {items.map(n => {
              const m = levelMeta[n.level] || levelMeta.info;
              const Icon = m.icon;
              return (
                <div key={n.id} className={`bg-slate-900 border ${m.color.split(" ")[2]} rounded-md p-4 flex items-start gap-3`} data-testid={`notif-${n.id}`}>
                  <div className={`p-2 rounded-md ${m.color}`}><Icon size={16} /></div>
                  <div className="flex-1">
                    <div className="font-semibold text-white">{n.title}</div>
                    <div className="text-sm text-slate-400 mt-0.5">{n.message}</div>
                    <div className="text-[10px] text-slate-600 font-mono mt-2">{new Date(n.created_at).toLocaleString("it-IT")}</div>
                  </div>
                  {!n.read && <span className="text-[10px] px-2 py-0.5 bg-blue-600 text-white rounded uppercase">Nuovo</span>}
                </div>
              );
            })}
          </div>
        )}
      </PageContent>
    </div>
  );
}
